export default __webpack_public_path__ + "static/media/Snd1.e84cadd5.mp3";